// TODO: translate descriptions
export const CONSENT_ELEMENT_TYPES = {
    SIGNATURE: {
        type: 'SIGNATURE',
        label: 'Signature',
        icon: 'pen',
        color: '#3B82F6',
        defaultWidth: 0.3,
        defaultHeight: 0.05,
        description: 'Signature field for signing the document',
    },
    INITIALS: {
        type: 'INITIALS',
        label: 'Initials',
        icon: 'pen',
        color: '#8B5CF6',
        defaultWidth: 0.1,
        defaultHeight: 0.05,
        description: 'Initials field',
    },
    DATE_INPUT: {
        type: 'DATE_INPUT',
        label: 'Date',
        icon: 'calendar',
        color: '#10B981',
        defaultWidth: 0.2,
        defaultHeight: 0.04,
        description: 'Date input field',
    },
    TEXT_INPUT: {
        type: 'TEXT_INPUT',
        label: 'Text',
        icon: 'text',
        color: '#F59E0B',
        defaultWidth: 0.25,
        defaultHeight: 0.04,
        description: 'Free text input field',
    },
    CHOICE: {
        type: 'CHOICE',
        label: 'Choice',
        icon: 'checkbox',
        color: '#EF4444',
        defaultWidth: 0.15,
        defaultHeight: 0.04,
        description: 'Multiple choice field',
    },
};
export const ELEMENT_TYPE_LIST = Object.values(CONSENT_ELEMENT_TYPES);
export const CONSENT_STORAGE_KEY = 'consent_documents_poc';
export const SIGNER_ROLES = [
    { value: 'participant', label: 'Participant' },
    { value: 'non-signing participant', label: 'Non-signing participant' },
    { value: 'third party', label: 'Third party' },
    { value: 'internal signer', label: 'Internal signer' },
];
